module.exports = __webpack_public_path__ + "img/session3_4.f3169d52.png";